import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

import { IconProps } from './';

export const LoadingIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" className={cn('animate-spin', className)} ref={ref} {...props}>
      <defs>
        <linearGradient id="half-blue" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="50%" stopColor="rgb(var(--default-blue))" />
          <stop offset="50%" stopColor="white" />
        </linearGradient>
      </defs>
      <path
        d="M10 19C7.91771 19.0018 5.8992 18.2816 4.28844 16.9619C2.67769 15.6423 1.57435 13.805 1.16645 11.763C0.758545 9.72106 1.07132 7.60084 2.05147 5.76365C3.03161 3.92646 4.61849 2.48598 6.54168 1.68768C8.46487 0.889371 10.6054 0.782637 12.5984 1.38566C14.5915 1.98869 16.3138 3.26416 17.4719 4.99473C18.6299 6.7253 19.1521 8.80389 18.9493 10.8763C18.7466 12.9487 17.8315 14.8867 16.36 16.36C14.6738 18.0483 12.3861 18.9979 10 19ZM10 4C8.61181 3.99878 7.26613 4.47895 6.1923 5.35871C5.11846 6.23846 4.3829 7.46335 4.11097 8.82465C3.83903 10.186 4.04755 11.5994 4.70098 12.8242C5.35441 14.049 6.41233 15.0093 7.69445 15.5415C8.97658 16.0738 10.4036 16.1449 11.7323 15.7429C13.061 15.3409 14.2092 14.4906 14.9812 13.3368C15.7533 12.1831 16.1014 10.7974 15.9662 9.4158C15.8311 8.0342 15.221 6.74221 14.24 5.76C13.1159 4.63446 11.5908 4.0014 10 4Z"
        fill="url(#half-blue)"
      />
    </svg>
  );
});

export default LoadingIcon;
